import { QueryClient, QueryCache, MutationCache } from '@tanstack/react-query';
import { toast } from '../components/ui/toast.js';

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      // eslint-disable-next-line no-console
      console.error('[query error]', error);
      const e = error as { message?: string; code?: string; status?: number };
      const msg = e.message || `Request failed (${e.code ?? e.status ?? 'unknown'})`;
      toast.error(msg);
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      // eslint-disable-next-line no-console
      console.error('[mutation error]', error);
      const e = error as { message?: string; code?: string; status?: number };
      const msg = e.message || `Request failed (${e.code ?? e.status ?? 'unknown'})`;
      toast.error(msg);
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 30_000, // 30 seconds
      retry: (failureCount, error) => {
        // Don't retry on 4xx errors
        const status = (error as { status?: number }).status;
        if (status && status >= 400 && status < 500) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
